interface SEOProps {
    pageType: 'category' | 'product';
    name: string;
    section: string;
    description?: string;
}

export default function setMetaTags({ pageType, name, section, description = '' }: SEOProps) {
    const ZARA_PREOWNED = " | Zara Preowned";
    const defaultCategoryDescription = "Buy and sell your Zara's used clothes, shoes, and accessories. Join our community to find great deals and give your pre-loved Zara items a new home.";
    if (name ){
        const title = `${name} ${section}${ZARA_PREOWNED}`;
        document.title = title;
    }
    const descriptionContent = pageType === 'category' ? defaultCategoryDescription : description || defaultCategoryDescription;


    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
        const newMetaDescription = document.createElement("meta");
        newMetaDescription.name = "description";
        document.head.appendChild(newMetaDescription);
    }
    metaDescription.setAttribute('content', descriptionContent);
}

